import { Component } from '@angular/core';

import { IdentificationOverviewComponent } from './components/identification-overview/identification-overview.component';

@Component({
  templateUrl: './identification.component.html',
  imports: [IdentificationOverviewComponent],
})
export class IdentificationComponent {}
